module.exports = __webpack_public_path__ + "img/option-4.0a048fbd.png";